import type { Coords } from 'google-map-react';

import type { DeliveryZone } from '~/api/DeliveryAddress';
import { company } from '~/company/Company';
import { DELIVERY_ZONES_STYLE } from '~/components/ModalDeliveryAddress/GMap/constants';

import { mainStore } from '~/stores';

export const isInsideZone = (position: Coords, polygon: any): boolean => {
  const result = google.maps.geometry?.poly.containsLocation(
    new google.maps.LatLng(position.lat, position.lng),
    polygon,
  );

  return Boolean(result);
};

const getPolygonCoords = (zone: DeliveryZone) =>
  mainStore.flatArray(
    zone.polygon.segments.map((segment) =>
      Object.values(segment).map((coord) => ({
        lat: coord.latitude,
        lng: coord.longitude,
      })),
    ),
  );

export const createPolygonForZone = (
  zone: DeliveryZone,
): google.maps.Polygon => {
  const convert = getPolygonCoords(zone);
  const isPudo = zone.displayType === 'pudo';

  const style =
    isPudo || company.zonePolygonHidden
      ? { strokeOpacity: 0, fillOpacity: 0 }
      : DELIVERY_ZONES_STYLE[zone.priority as number] ||
        DELIVERY_ZONES_STYLE[100];

  return new google.maps.Polygon({
    paths: convert,
    strokeWeight: 1,
    fillColor: zone.color,
    strokeColor: zone.color,
    // @ts-expect-error FIXME: migrate to noUncheckedIndexedAccess: true
    fillOpacity: style.fillOpacity,
    // @ts-expect-error FIXME: migrate to noUncheckedIndexedAccess: true
    strokeOpacity: style.strokeOpacity,
  });
};

export const getZoneCentroid = (zone: DeliveryZone): Coords => {
  const coords = getPolygonCoords(zone);
  return {
    lat: coords.reduce((sum, c) => sum + c.lat, 0) / coords.length,
    lng: coords.reduce((sum, c) => sum + c.lng, 0) / coords.length,
  };
};
